import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta-anchor');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  return <AnimatePresence data-id="element-35" data-mp="196ooyqc6tt1a">
      {visible ? <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-sm" data-id="element-36" data-mp="197rhf2p5s3jb">
          <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-37" data-mp="21buletunaysu">
            <div className="hidden shrink-0 sm:block" data-id="element-38" data-mp="26b76pa5vbxtb">
              <p className="font-display text-xl font-bold leading-none text-navy" data-id="element-39" data-mp="269w1d5wryi03">$27</p>
              <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-navy/55" data-id="element-40" data-mp="1rd51ywn3p6ah">
                One-time
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={handleClick} className="mp-shake flex flex-1 items-center justify-center gap-2 rounded-xl bg-rose px-4 py-3.5 text-[14px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-cta transition-colors duration-200 ease-out hover:bg-rose-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rose sm:text-base" data-id="element-41" data-mp="1ieb99hcw5027">
              <LockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-42" data-mp="3f9w78i1jtc4b" />
              Get 5-MIN MENOPAUSE™ — $27
            </a>
          </div>
          <p className="mx-auto mt-1.5 max-w-xl text-center text-[10.5px] font-semibold text-navy/55" data-id="element-43" data-mp="36clqih5yous0">
            Instant access · Lifetime access · 7-day guarantee
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}